<div class="kt-subheader kt-grid__item mb-0" [ngClass]="{'kt-container--clear': clear}">
    <div class="kt-container" [ngClass]="{'kt-container--fluid': fluid}">
        <div id="kt_subheader" class="subheader py-2 py-lg-6 subheader-solid">
            <h5 class="text-dark my-1 mr-5"> {{title}} </h5>
        </div>
    </div>
</div>
